import { useState, useMemo } from 'react'
import { useEvents } from '@contexts/EventsContext'
import { Hero, EventList, Button, Loading } from '@components'
import './Home.css'

const Home = () => {
  const { upcomingEvents, nextEvents, featuredEvent, eventsLoading, nextEventsLoading } = useEvents() // Consume from EventsContext
  const [showAllNext, setShowAllNext] = useState(false)

  const visibleNextEvents = useMemo(() => {
    const events = nextEvents || [];
    return showAllNext ? events : events.slice(0, 4);
  }, [showAllNext, nextEvents]);

  return (
    <main className="home">
      {eventsLoading && !featuredEvent ? (
        <div className="home__loading-container">
          <Loading size="lg" text="Carregando eventos..." />
        </div>
      ) : (
        <>
          <Hero event={featuredEvent} hasOtherEvents={upcomingEvents.length > 0 || nextEvents.length > 0} />
          {/* Upcoming Events */}
          {(upcomingEvents.length > 0 || eventsLoading) && (
            <section className="home__section container">
              <EventList
                title="Vendas liberadas"
                events={upcomingEvents}
                loading={eventsLoading}
                emptyMessage="Nenhum evento disponível no momento"
              />
            </section>
          )}

          {/* Next Events */}
          {(nextEvents.length > 0 || nextEventsLoading) && (
            <section className="home__section container">
              <EventList
                title="Próximos eventos"
                events={visibleNextEvents}
                loading={nextEventsLoading}
              />

              {nextEvents.length > 4 && (
                <div className="home__load-more">
                  <Button
                    variant="secondary"
                    onClick={() => setShowAllNext(!showAllNext)}
                  >
                    {showAllNext ? 'Mostrar menos' : 'Carregar mais eventos'}
                  </Button>
                </div>
              )}
            </section>
          )}        </>
      )}
    </main>
  )
}

export default Home
